import gql from 'graphql-tag';

export const CLAIM_STORE_PROGRAM_PARTICIPANT = gql`
  mutation ClaimStoreProgramParticipant(
    $storeId: String!
    $programId: String!
    $type: ClaimStoreType!
  ) {
    claimStoreProgramParticipant(
      storeId: $storeId
      programId: $programId
      type: $type
    ) {
      success
    }
  }
`;

export const UPDATE_PROGRAM_PARTICIPANT = gql`
  mutation UpdateProgramParticipant(
    $attachment: AttachmentInput!
    $programId: String!
    $status: StoreProgramStatus!
    $storeId: String!
    $unverifiedReasonData: [ProgramUnverifiedReasonDataInput!]
    $preferenceData: [PreferenceChecklistInput!]!
  ) {
    updateStoreProgramParticipant(
      attachment: $attachment
      programId: $programId
      status: $status
      storeId: $storeId
      unverifiedReasonData: $unverifiedReasonData
      preferenceData: $preferenceData
    ) {
      success
    }
  }
`;
